import apiClient from './client'
import type {
    Parte,
    ParteTramo,
    CreateMisParteRequest,
    UpdateMisParteRequest,
    CreateParteTramoRequest,
    ParteTramoFormData,
    PaginatedResponse,
} from '@/types/parte'
import type { Auxiliar } from '@/types/auxiliar'
import type { Aviso } from '@/types/aviso'
import type { Cliente } from '@/types/cliente'

interface MisParteCreateContext {
    defaultTipoParteId: string | null
    defaultTipoParte: Auxiliar | null
    aviso: Aviso | null
    cliente: Cliente | null
}

interface ParteTramoCreateContext {
    defaultTipoTramoId: string | null
    defaultTipoTramo: Auxiliar | null
    defaultInicio: string | null
    defaultFinal: string | null
}

export const misPartesApi = {
    getAll: (params?: { search?: string; estado?: 'abiertos' | 'cerrados'; idCliente?: string; page?: number; pageSize?: number; todos?: 1 }) =>
        apiClient.get<PaginatedResponse<Parte>>('/partes/mis', { params }).then((r) => r.data),

    getById: (id: number) =>
        apiClient.get<Parte>(`/partes/mis/${id}`).then((r) => r.data),

    getCreateContext: (params?: { idAviso?: number }) =>
        apiClient.get<MisParteCreateContext>('/partes/mis/context', { params }).then((r) => r.data),

    create: (data: CreateMisParteRequest) =>
        apiClient.post<Parte>('/partes/mis', data).then((r) => r.data),

    update: (id: number, data: UpdateMisParteRequest) =>
        apiClient.put<Parte>(`/partes/mis/${id}`, data).then((r) => r.data),

    getTramos: (id: number) =>
        apiClient.get<ParteTramo[]>(`/partes/mis/${id}/tramos`).then((r) => r.data),

    getTramoCreateContext: (id: number) =>
        apiClient.get<ParteTramoCreateContext>(`/partes/mis/${id}/tramos/context`).then((r) => r.data),

    createTramo: (id: number, data: ParteTramoFormData) => {
        const payload: CreateParteTramoRequest = {
            idAviso: data.idAviso,
            idTipoTramo: data.tipoTramo?.idAuxiliar || '',
            ...(data.inicio ? { inicio: data.inicio } : {}),
            ...(data.final ? { final: data.final } : {}),
        }

        return apiClient.post<ParteTramo>(`/partes/mis/${id}/tramos`, payload).then((r) => r.data)
    },

    deleteTramo: (id: number, idParteTramo: number) =>
        apiClient.delete(`/partes/mis/${id}/tramos/${idParteTramo}`),
}
